import { render, staticRenderFns } from "./BalanceType.vue?vue&type=template&id=2c3e4190&scoped=true"
import script from "./BalanceType.vue?vue&type=script&lang=js"
export * from "./BalanceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e4190",
  null
  
)

export default component.exports